import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 180
    }
  })
)
